module.exports = __webpack_public_path__ + "static/media/2.95fe0a9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/tmsAbout/img/2.png
// module id = 436
// module chunks = 0